// extracted by mini-css-extract-plugin
module.exports = {"SideHeader":"SideHeader_SideHeader__2zoWU","LogoText":"SideHeader_LogoText__3EWgf","AnimationName":"SideHeader_AnimationName__wFlO3"};